export default class cfaAddressValidate {
  init() {
    const $addressOptionsContainer = $('#address_options_container');

    if ($addressOptionsContainer.length > 0) {
      this.addressSelectionInit();
    }
  }

  addressSelectionInit = () => {
    const $addressSelectButtons = $('.addressSelectButton');
    $addressSelectButtons.on('click', function () {
      const addressIndex = this.id.replace('address_option_', '');
      const $selectButton = $(`#${this.id}`);
      $('#address_city').val($(`#city_${addressIndex}`).text());
      $('#address_county').val($(`#county_${addressIndex}`).text());
      $('#address_state').val($(`#state_${addressIndex}`).text());
      $('#address_country').val($(`#country_${addressIndex}`).text());

      $selectButton.text('Selected');
      $selectButton.addClass('active');

      $addressSelectButtons.not($selectButton).removeClass('active');
      $addressSelectButtons.not($selectButton).text('Select');

      $('input[type="submit"]').prop('disabled', false);
    });
  };
}
